import { Fragment } from "react";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Text,
} from "@generalapplications/ui";

import { useBreadcrumbs } from "@/app/common/hooks/useBreadcrumbs";

/**
 * The trail above a detail page, drawn as PlantHarvester draws its trail.
 *
 * An index page has no trail and no `<nav>`, but keeps the trail's line of
 * space, so a hero sits at the same height on every page and does not jump
 * as a reader moves between an index and its details.
 */
export function Breadcrumbs() {
  const crumbs = useBreadcrumbs();

  if (crumbs.length < 2)
    return (
      <Box paddingBottom="xl" aria-hidden="true">
        <Text>{" "}</Text>
      </Box>
    );

  return (
    <Breadcrumb hideOnPrint spaceBelow>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <Fragment key={crumb.label}>
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {crumb.href && !isLast ? (
                  <BreadcrumbLink href={crumb.href}>
                    {crumb.label}
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
